import { Component, ElementRef, OnInit, AfterViewInit, ViewChild } from "@angular/core";
// import { BotDirective, BotHelperDirective, StyleSetDirective, BotService, ComService, IPayload, DEFAULT_OPTIONS } from 'ngx-microsoft-bot-framework';

@Component({
    selector: 'chat-bot',
    templateUrl: './chat-bot.component.html',
    styleUrls: ['./chat-bot.component.css'],
    standalone: false
})
export class ChatBotComponent implements OnInit, AfterViewInit {
  @ViewChild("botWindow", { static: false }) botWindowElement: ElementRef;
  passViewChild: ViewChild;

  // payload: IPayload = {
  //   secret: 'vkJHFWWbSuM.35qi_1cOndUN1Q2mmnvLwTZZQ2SQrvi9_RaKyOXlqm0',
  //   url: 'https://webchat.botframework.com/api/tokens',
  //   secretSetting: true,
  //   webSocket: true
  // };

  // stylesetPayload: DEFAULT_OPTIONS = {
  //   rootHeight: '100%',
  //   botAvatarInitials: 'BF',
  //   userAvatarInitials: 'CH',
  //   backgroundColor: '#131313',
  //   root: {
  //     /* width */
  //     ' ::-webkit-scrollbar': {
  //       width: '3px'
  //     },
  //   },
  //   textContent: {
  //     fontFamily: '\'Comic Sans MS\', \'Arial\', sans-serif',
  //     fontWeight: 'bold',
  //   }
  // };
  // styleOptionsPayload: DEFAULT_OPTIONS = {
  //   rootHeight: '100%',
  //   botAvatarInitials: 'BF',
  //   userAvatarInitials: 'CH',
  //   backgroundColor: 'red',
  // };

  public showChat: boolean = false;

  constructor(
    // private comService: ComService,
    // private bot: BotDirective
  ) { 
    
  }

  ngOnInit() {
    //this.obtainStylePayload();
    this.obtainLocalToken();
  }

  ngAfterViewInit(): void {
    this.setBotDirective();
}

  setBotDirective(): void {
    this.passViewChild = this.botWindowElement.nativeElement;
    // this.bot.botDirective(this.passViewChild);
  }

  obtainLocalToken() {
      //this.comService.obtainToken(this.payload);
  }

  obtainStylePayload() {
      //this.comService.obtainStylePayload(this.stylesetPayload, this.styleOptionsPayload)
  }

  public toggleChat(): void {
    this.showChat = !this.showChat;
  }

}
